import React from "react";
import { Typography } from "material-ui";
import FuelChargeImage from "./../../../images/fuel-charge.png";
import DefuelImage from "./../../../images/fuel-defuel.png";

const fakeData = {
  Evento: 105,
  Volumen: "60 Lts",
  Unidad: "TRA 01",
  Fecha: "2018-08-29 00:46:16"
};

const EventosFuelTile = props => {
  const { data } = props;

  return (
    <div className="dashboard-tile">
      <div className="tile-header">
        <Typography
          variant="title"
          align="center"
          color="primary"
          className="headline"
        >
          Último evento de combustible
        </Typography>
      </div>
      <div className="tile-body">
        <Typography
          variant="title"
          align="center"
          color="primary"
          className="headline"
        >
          <img
            style={{ width: "2.5rem" }}
            src={fakeData.Evento == 105 ? FuelChargeImage : DefuelImage}
          />
        </Typography>
        <Typography
          variant="display1"
          align="center"
          color="textSecondary"
          className="headline"
        >
          {fakeData.Volumen}
        </Typography>
      </div>
      <div className="tile-footer">
        <Typography
          variant="title"
          align="center"
          color="primary"
          className="headline"
        >
          {fakeData.Unidad}
        </Typography>
        <Typography
          variant=" "
          align="center"
          color="textSecondary"
          className="headline"
        >
          {fakeData.Fecha}
        </Typography>
      </div>
    </div>
  );
};

export default EventosFuelTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/EventosFuelTile.js